import { Component, OnInit, Input } from '@angular/core';
import { Shared } from '../shared.service';

@Component({
  selector: 'user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit {

  @Input() user;
  popup = false;
  expand = false;
  whitelist = ['user_name', 'user_inner', 'user_email'];

  constructor(public shared: Shared) { }

  ngOnInit() {
      //console.log(this.user);
  }

  canViewUser(){
    return true;
     /* switch(this.shared.firebase_user.role){
          case 'admin':
              return true;
          case 'manager':
              if(this.user.role === 'admin'){
                  return false;
              }
              return true;
          case 'budtender':
              return false;
      }
    */
  }

  toggleExpand(event){
      let t = event.target;
      if(t.localName === 'div' && (this.whitelist.includes(t.className))){
          this.expand = !this.expand;
      }
  }

  save(){
      const key = this.user.$key;
      delete this.user.$key;
      this.shared.UsersRef.update(key, this.user);
  }

}



// WEBPACK FOOTER //
// ./src/app/user/user.component.ts